/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPasswordCharacters } from './CRSFSecReviewPasswordCharacters';
import {
    CRSFSecReviewPasswordCharactersFromJSON,
    CRSFSecReviewPasswordCharactersFromJSONTyped,
    CRSFSecReviewPasswordCharactersToJSON,
} from './CRSFSecReviewPasswordCharacters';
import type { CRSFSecReviewPasswordComposition } from './CRSFSecReviewPasswordComposition';
import {
    CRSFSecReviewPasswordCompositionFromJSON,
    CRSFSecReviewPasswordCompositionFromJSONTyped,
    CRSFSecReviewPasswordCompositionToJSON,
} from './CRSFSecReviewPasswordComposition';

/**
 * 
 * @export
 * @interface CRSFSecReviewPasswordsAggregate
 */
export interface CRSFSecReviewPasswordsAggregate {
    /**
     * 
     * @type {CRSFSecReviewPasswordCharacters}
     * @memberof CRSFSecReviewPasswordsAggregate
     */
    characters: CRSFSecReviewPasswordCharacters;
    /**
     * 
     * @type {CRSFSecReviewPasswordComposition}
     * @memberof CRSFSecReviewPasswordsAggregate
     */
    composition: CRSFSecReviewPasswordComposition;
}

/**
 * Check if a given object implements the CRSFSecReviewPasswordsAggregate interface.
 */
export function instanceOfCRSFSecReviewPasswordsAggregate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "characters" in value;
    isInstance = isInstance && "composition" in value;

    return isInstance;
}

export function CRSFSecReviewPasswordsAggregateFromJSON(json: any): CRSFSecReviewPasswordsAggregate {
    return CRSFSecReviewPasswordsAggregateFromJSONTyped(json, false);
}

export function CRSFSecReviewPasswordsAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPasswordsAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'characters': CRSFSecReviewPasswordCharactersFromJSON(json['characters']),
        'composition': CRSFSecReviewPasswordCompositionFromJSON(json['composition']),
    };
}

export function CRSFSecReviewPasswordsAggregateToJSON(value?: CRSFSecReviewPasswordsAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'characters': CRSFSecReviewPasswordCharactersToJSON(value.characters),
        'composition': CRSFSecReviewPasswordCompositionToJSON(value.composition),
    };
}

